/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'icap-profile';

export const icapProfileModalBreadcrumbTitle = `${prefix}.icapProfileModalBreadcrumbTitle`;

export const ENGLISH = {
    [icapProfileModalBreadcrumbTitle]: 'ICAP Profile',
};
